import React from "react";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { findArticle, ARTICLES } from "./resourcesData.jsx";
import NextSteps from "./NextSteps.jsx";

export default function ArticlePage({ slug }) {
  const article = findArticle(slug);

  if (!article) {
    return (
      <div className="min-h-screen bg-paper text-nearblack flex flex-col">
        <Nav heroVisible={false} />
        <main className="flex-1 flex items-center justify-center px-6 text-center pt-24">
          <div>
            <p className="eyebrow mb-4">404</p>
            <h1
              className="font-serif text-nearblack"
              style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)", fontWeight: 300 }}
            >
              Article not found.
            </h1>
            <a
              href="/resources"
              className="mt-8 inline-flex items-center gap-1.5 text-camel uppercase tracking-[0.22em]"
              style={{ fontSize: "11px", fontWeight: 600 }}
            >
              Back to Resources
            </a>
          </div>
        </main>
      </div>
    );
  }

  const Body = article.Body;

  return (
    <div className="min-h-screen bg-paper text-nearblack font-sans antialiased">
      <Nav heroVisible={false} />

      {/* Featured image */}
      <section className="pt-24 md:pt-32" data-testid="article-image-section">
        <div className="max-w-[1080px] mx-auto px-6 md:px-10">
          <div className="bg-nearblack/5 overflow-hidden">
            <img
              src={article.image}
              alt={article.imageAlt}
              className="w-full aspect-[16/9] md:aspect-[2/1] object-cover"
              loading="eager"
            />
          </div>
        </div>
      </section>

      {/* Title + meta */}
      <section className="pt-12 md:pt-16 pb-2" data-testid="article-header">
        <div className="max-w-[720px] mx-auto px-6 md:px-10">
          <p className="eyebrow" data-testid="article-eyebrow">
            {article.eyebrow}
          </p>
          <h1
            data-testid="article-title"
            className="font-serif text-nearblack mt-7 leading-[1.08] text-balance"
            style={{ fontSize: "clamp(2.2rem, 4.6vw, 3.4rem)", fontWeight: 300 }}
          >
            {article.title}
          </h1>
          <p
            className="mt-8 uppercase text-stonegrey"
            style={{ fontSize: "10.5px", letterSpacing: "0.22em", fontWeight: 500 }}
          >
            By Liz DiRocco
          </p>
          <span className="block w-[60px] h-px bg-camel mt-8" />
        </div>
      </section>

      {/* Body */}
      <section className="pt-10 pb-16 md:pb-20" data-testid="article-body">
        <div className="max-w-[720px] mx-auto px-6 md:px-10">
          <Body />
        </div>
      </section>

      {/* Disclaimer */}
      <section className="pb-12" data-testid="article-disclaimer">
        <div className="max-w-[720px] mx-auto px-6 md:px-10">
          <p className="text-stonegrey italic font-light text-[13.5px] leading-[1.7] text-center max-w-[600px] mx-auto">
            Educational content only. Not financial, tax, legal, or investment advice. Individual
            results and suitability depend on personal circumstances.
          </p>
        </div>
      </section>

      <NextSteps />

      <Footer />
    </div>
  );
}

// Keep the ARTICLES export reachable so other modules can validate slugs.
export { ARTICLES };
